<template>
  <div class="hm-chip" :style="{backgroundColor: isMeal ? `rgb(from ${color} r g b / 0.12)` : '#F6F6F6'}">
    <span
      class="hm-chip__text"
      :class="{'hm-chip__text--meal': isMeal}"
      :style="{color}"
    >
      <slot />
    </span>
    <slot name="icon" />
  </div>
</template>

<script>
export default {
  name: 'HMChip',
  props: {
    color: {
      type: String,
      default: '#76A9B4'
    },
    isMeal: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>
.hm-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 42px;
  height: 24px;
  border-radius: 6px;
}

.hm-chip__text {
  font-family: 'CoreSansCR', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
}

.hm-chip__text--meal {
  font-size: 15px;
  font-weight: 400;
}
</style>